import React from 'react';
import Item from '../components/Item';

class ItemList extends React.Component {

    render() {
        let cart = [];
        //http://sheleg.com/pirsum/course.jpg
        //http://sheleg.com/pirsum/course1.jpg
        //http://sheleg.com/pirsum/course2.png

        // Insert all available items into cart
        this.props.allItems.map((item) => cart.push(
            {
                itemNo: item.itemNo,
                quantity: item.quantity,
                hebDescription: item.hebDescription,
                engDescription: item.engDescription,
                picDescription: item.picDescription,
                picFile: item.picFile,
                hebName: item.hebName,
                engName: item.engName,
                priceNis: item.priceNis,
                priceUsd: item.priceUsd,
                category: item.category
            }
        ));

        const items = cart.map((item) => {
            let visible = item.category.toString() === this.props.selectedCategory ? true : false;
            if (this.props.selectedCategory === '0')
                visible = true;
            return <Item
                //Globals
                lang={this.props.lang}
                currentURL={this.props.currentURL}
                //logoURL={this.props.logoURL}
                vendorData={this.props.vendorData}
                currency={this.props.currency}
                //Variables
                key={item.itemNo}
                itemNo={item.itemNo}
                category={item.category}
                hebName={item.hebName}
                engName={item.engName}
                hebDescription={item.hebDescription}
                engDescription={item.engDescription}
                priceNis={item.priceNis}
                priceUsd={item.priceUsd}
                quantity={item.quantity}
                picture={item.picFile}
                picDescription={item.picDescription}
                isVisible={visible}
                isFull={false} // Waiting for API
                //Methods
                addToCart={this.props.addToCart}
                removeFromCart={this.props.removeFromCart}
                changeScreen={this.props.changeScreen}
            />;
        });// boxShadow: ''0px 2px 2px 1px #888888'
        return (
            <div className="col-12" style={{ padding: '10px 10px 10px 10px' }}>
                {items}
            </div>
        );
    }
}

export default ItemList;
